import { SearchRegisteredUser } from '@domains/admin/models/clerk-probate-http.models';
import { AutocompleteOption } from '@shared/components/autocomplete';

const formatUserToAutocompleteOptionLabel = (
  user: SearchRegisteredUser,
): string => {
  const lastName = user.lastName ? user.lastName + ', ' : '';
  const firstName = user.firstName;
  const middleName = user.middleName ? ' ' + user.middleName : '';
  const email = user.email ? ', ' + user.email : '';
  return lastName + firstName + middleName + email;
};

export const getFormattedAutoCompleteOptions = (
  users: SearchRegisteredUser[],
  searchType: 'firstName' | 'email',
): AutocompleteOption[] => {
  return users.map((user) => ({
    value: String(user.id),
    label: String(
      searchType === 'firstName' ? user.firstName : (user.email ?? ''),
    ),
    listLabel: formatUserToAutocompleteOptionLabel(user),
  }));
};
